module.exports = __webpack_public_path__ + "media/packs/images/search/pier-79e99e9bf3d88a2db5d9834b672cefe6.svg";